import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const SettingsSharedState = {}

export const SettingsSharedActions = {
  getSelectOptions: async (_, model) => {
    return axiosRequest.
      get(`/${model}`).
      then(({ data }) => data).
      catch(handleError)
  },

  getSelectOptionList: async (_, { model, field }) => {
    return axiosRequest.
      get(`/options/${model}/${field}`).
      then(({ data }) => data.options).
      catch(handleError)
  },
}

export const SettingsSharedMutations = {}

export const SettingsSharedGetters = {}
